export const RESET_API_ERROR = 'RESET_API_ERROR';

export const SET_API_ERROR = 'SET_API_ERROR';

export const ACTIVATE_SELECTED_CM_INTEGRATION =
  'ACTIVATE_SELECTED_CM_INTEGRATION';
